import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PredefinedDataGetMixedPathParameters } from 'api/actions/predefined-data-get-mixed/predefined-data-get-mixed-path-parameters';
import { PredefinedDataGetMixedResponse } from 'api/actions/predefined-data-get-mixed/predefined-data-get-mixed-response';

type PredefinedDataGetMixedQueryParameters = Record<string, any>;

/**
 * The path of the PredefinedDataGetMixed action.
 */
export const predefinedDataGetMixedActionPath = new SweetPath<keyof PredefinedDataGetMixedPathParameters>(
  '/api/predefined-data/mixed/{predefinedDataTypeId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized PredefinedDataGetMixed actions.
 */
export default function createPredefinedDataGetMixedAction(axios: AxiosInstance) {
  return function predefinedDataGetMixedAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: PredefinedDataGetMixedPathParameters;
    query?: PredefinedDataGetMixedQueryParameters;
  }) {
    const path = predefinedDataGetMixedActionPath.insert(parameters);

    return axios.request<PredefinedDataGetMixedResponse, PredefinedDataGetMixedResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
